export default "__VITE_ASSET__B_5n4QnJ__"